export const headerLinks = [
    { path: '/', label: 'home' },
    { path: '/products', label: 'products' },
    { path: '/subscriptions', label: 'subscriptions' },
    { path: '/features', label: 'features' },
    { path: '/coming-soon', label: 'coming_soon' },
    { path: '/contact', label: 'contact_us' },
];

export const footerProductLinks = [
    { path: '/subscriptions', label: 'subscriptions' },
    { path: '/features', label: 'features' },
    { path: '/products', label: 'products' },
    { path: '/coming-soon', label: 'coming_soon' },
];

export const footerResourcesLinks = [
    { path: '/help-center', label: 'help_center' },
    { path: '/docs/getting-started', label: 'nav_documentation' },
    { path: '/faq', label: 'nav_faq' },
    { path: '/docs/security', label: 'nav_security' },
    { path: '/changelog', label: 'nav_changelog' },

];

export const footerTermsLinks = [
    { path: '/terms', label: 'terms_conditions' },
    { path: '/privacy', label: 'privacy_policy' },
];
